import { create } from 'zustand';

/**
 * Global menu → full-screen World Cup rules / welcome flow on top of the current screen
 * (no navigation). Tab route welcome uses `readWorldCupWelcomeCompleted` in `worldcup/_layout`.
 */
interface WorldCupWelcomeMenuState {
  rulesOverlayOpen: boolean;
  welcomeOverlayVisible: boolean;
  openWorldCupRulesFromMenu: () => void;
  closeWorldCupRulesOverlay: () => void;
  setWelcomeOverlayVisible: (isVisible: boolean) => void;
}

export const useWorldCupWelcomeMenuStore = create<WorldCupWelcomeMenuState>((set) => ({
  rulesOverlayOpen: false,
  welcomeOverlayVisible: false,
  openWorldCupRulesFromMenu: () => set({ rulesOverlayOpen: true }),
  closeWorldCupRulesOverlay: () => set({ rulesOverlayOpen: false }),
  setWelcomeOverlayVisible: (isVisible) => set({ welcomeOverlayVisible: isVisible }),
}));
